import ApiService from '../apiservice'

export default class PontuacaoUsuario extends ApiService {
  constructor() {
    super('/pontuacaoUsuario')
  }

  gerarPontuacaoUsuario(ano,mesAtual,mesAnterior,usuario,empresa) {
    return this.get(`/pontos-usuario?ano=${ano}&mesAtual=${mesAtual}&mesAnterior=${mesAnterior}&usuario=${usuario}&empresa=${empresa}`);
  }
}